import { authConfig } from "../apiConfig";

// for get all completed equipment utilization_reports
export const get_equipment_utilization_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`generateMonthlyEquipmentUtilizationReport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
    
};